import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface UiToastData {
  message: string;
}

@Component({
  selector: 'app-ui-toast',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './ui-toast.component.html',
  styleUrl: './ui-toast.component.css',
})
export class UiToastComponent {
  data = inject<UiToastData>(MAT_SNACK_BAR_DATA);
  private snackBarRef = inject(MatSnackBarRef);

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
